import React from 'react';
import { NavLink } from 'react-router-dom';
import PillButton from '../components/PillButton';
import SEO from '../components/SEO';
import FaqSchema from '../components/FaqSchema';

function About() {
  return (
    <div className="container mt-5">
      <SEO 
        title="About The Code-E Project | Our Mission and Team"
        description="Learn about The Code-E Project's mission to provide accessible, high-quality web development education with a focus on HTML, CSS, JavaScript, and more."
        keywords="about, web development education, coding education, frontend development, The Code-E Project team"
      />
      <FaqSchema />
      
      {/* Hero Section */}
      <header className="hero-section text-center" role="banner">
        <div className="container">
          <h1>About The Creators and Trainers</h1>
          <p className="lead">
            Get to know the creator behind The Code-E Project and the trainers dedicated to helping put Australian Developers on the Map
          </p>
        </div>
      </header>

      {/* Main Content */}
      <main className="container py-5" role="main">
        <section id="about-content" aria-labelledby="about-heading">
          <div className="text-center mb-4">
            <img
              src="https://github.com/CodieT93.png" // Placeholder: your GitHub avatar
              alt="Codie Tomlinson, creator of The Code-E Project"
              className="profile-pic"
            />
          </div>
          <h2 id="about-heading" className="text-center">Hi, I'm Codie</h2>
          <div className="row justify-content-center">
            <div className="col-md-8">
              <p>
                I'm a passionate full stack web developer and student of web technologies, dedicated to building clean, accessible, and user-friendly websites. I created The Code-E Project to share my knowledge of HTML, CSS, JavaScript, and Bootstrap with learners like you, all wrapped in a sleek black-and-white design that reflects my minimalist style.
              </p>
              <p>
                When I'm not coding, you can find me exploring new frameworks, contributing to open-source projects, or sipping coffee while sketching out my next web idea. My goal is to bridge the gap between beginners and advanced concepts, making web development approachable and fun.
              </p>
              <h3>Connect with Me</h3>
              <ul className="list-unstyled">
                <li>
                  <a href="https://github.com/CodieT93" target="_blank" rel="noopener noreferrer" className="footer-link">
                    GitHub
                  </a> - Check out my projects and contributions.
                </li>
                <li>
                  <a href="https://www.linkedin.com/in/codie-t-960727288/" target="_blank" rel="noopener noreferrer" className="footer-link">
                    LinkedIn
                  </a> - Let's connect professionally.
                </li>
                <li>
                  <a href="https://x.com/codietomlinson3" target="_blank" rel="noopener noreferrer" className="footer-link">
                    X
                  </a> - Follow me for tech updates and thoughts.
                </li>
              </ul>
              <div className="text-center mt-4">
                <NavLink to="/">
                  <PillButton>Back to Home</PillButton>
                </NavLink>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}

export default About;